import { storeCreator } from '@/utils/store/store.utils';

interface State {
  expandedItemId: string | null;
  setExpandedItemId: (id: string | null) => void;
  handleReset: () => void;
}

export const useExpandedItemStore = storeCreator<State>((set) => ({
  expandedItemId: null,
  setExpandedItemId: (id) => set({ expandedItemId: id }),
  handleReset: () => set({ expandedItemId: null }),
}));
